
      import Basket from './basket.vue'
      import type { App, Plugin } from 'vue'

      export const BasketPlugin: Plugin = {
        install(app: App) {
          app.component('Basket', Basket)
        },
      }
      export { Basket }
      